import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { addVisitor, addVisitProperty } from "../../reduxStore/action/visitorActions";
import { isEmpty, seo } from "utils/utils";

const CreateVisitorNext1 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState({});
  const params = useParams();
  const { _id = "" } = params || {};
  const { response = {} } = useSelector((state) => state.bulkVisitForm) || [];

  const visitSelector = useSelector((state) => state.visitor) || [];

  // useEffect(() => {
  //   setForm(response);
  // }, [response]);

  useEffect(() => {
    const { create, response } = visitSelector;
    if (create && response) {
      navigatpage("/newupload");
    }
  }, [visitSelector]);
  useEffect(() => {
    setForm(response);
  }, [response]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  // const handleInputlocation = (e) => {
  //   const nextFormState = {
  //     ...form,
  //     office_address: {
  //       ...form.office_address,
  //       location: e,
  //       latitude: "",
  //       longitude: "",
  //     },
  //   };

  //   setForm(nextFormState);
  // };
  // const onSelect = (latLng, location) => {
  //   const nextFormState = {
  //     ...form,
  //     office_address: {
  //       ...form.office_address,
  //       location: location,
  //       latitude: latLng.lat,
  //       longitude: latLng.lng,
  //     },
  //   };
  //   setForm(nextFormState);
  // };
  const checkBudget = (value = '') => {
    return value ? value : ""
  }
  const checkBudgetType = (value = '') => {
    return value ? value : "L"
  }

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("acquisition_source", 3); // for use backed side manage
    form.user_id && formData.append("user_id", form.user_id);
    formData.append("unverified_lead_id", _id);
    form.property_id && formData.append("property_id", form.property_id);
    form.property_title &&
      formData.append("property_title", form.property_title);
    form.configuration && formData.append("configuration", form.configuration);
    form.configuration_id &&
      formData.append("configuration_id", form.configuration_id);
    form.areain_sqlft && formData.append("areain_sqlft", form.areain_sqlft);
    form.expected_possession_date &&
      formData.append(
        "expected_possession_date",
        form.expected_possession_date
      );
    formData.append("min_budget", checkBudget(form.min_budget));
    formData.append("max_budget", checkBudget(form.max_budget));
    formData.append("min_budget_type", checkBudgetType(form.min_budget_type));
    formData.append("max_budget_type", checkBudgetType(form.max_budget_type));
    form.funding_type && formData.append("funding_type", form.funding_type);
    form.purpose && formData.append("purpose", form.purpose);
    form.first_name && formData.append("first_name", form.first_name);
    form.adhar_no && formData.append("adhar_no", form.adhar_no);
    form.pancard_no && formData.append("pancard_no", form.pancard_no);
    form.birth_date && formData.append("birth_date", form.birth_date);
    form.mobile && formData.append("mobile", form.mobile);
    form.whatsapp_no && formData.append("whatsapp_no", form.whatsapp_no);
    form.email && formData.append("email", form.email);
    form.location && formData.append("location", form.location);
    form.latitude && formData.append("latitude", form.latitude);
    form.longitude && formData.append("longitude", form.longitude);
    form.locality && formData.append("locality", form.locality);
    form.gender && formData.append("gender", form.gender);
    form.occupation && formData.append("occupation", form.occupation);
    form.coumpany_name && formData.append("coumpany_name", form.coumpany_name);
    form.desigantion && formData.append("desigantion", form.desigantion);
    form.office_address &&
      formData.append("office_address", (form.office_address));
    formData.append("min_emi_budget", checkBudget(form.min_emi_budget));
    formData.append("max_emi_budget", checkBudget(form.max_emi_budget));
    formData.append("min_emi_budget_type", checkBudgetType(form.min_emi_budget_type));
    formData.append("max_emi_budget_type", checkBudgetType(form.max_emi_budget_type));
    form.marital_status && formData.append("marital_status", form.marital_status);
    form.current_stay && formData.append("current_stay", form.current_stay);
    form.no_of_family_member && formData.append("no_of_family_member", form.no_of_family_member);
    form.property_type && formData.append("property_type", form.property_type);
    form.preferred_bank && formData.append("preferred_bank", form.preferred_bank);
    if (isEmpty(form.property_id)) {
      dispatch(addVisitProperty(formData));
    } else {
      dispatch(addVisitor(formData));
    }
  };

  useEffect(() => {
    seo({
      title: "Create Visitor",
      metaDescription: "Create visitor",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.createvisitor}
        url={"/newupload"}
        parentListing={strings.newuploadListing}
        titleactive={strings.CreateVisitor}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.createvisitor}</h5>
              </div>
              <form className="form theme-form">
                <div className="row">
                  <div className="col-8">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlLastName1">
                              {strings.occupation}
                            </label>
                            <div className="col">
                              <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                                <div className="radio radio-primary ">
                                  <input
                                    id="radio1"
                                    type="radio"
                                    name="occupation"
                                    value={"salaried"}
                                    checked={
                                      form.occupation === "salaried"
                                        ? true
                                        : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label className="mb-0" for="radio1">
                                    {strings.salaried}
                                  </label>
                                </div>
                                <div className="radio radio-primary  ml-5">
                                  <input
                                    id="radio2"
                                    type="radio"
                                    name="occupation"
                                    value={"self"}
                                    checked={
                                      form.occupation === "self" ? true : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label className="mb-0" for="radio2">
                                    {strings.selfEmployed}
                                  </label>
                                </div>
                                <div className="radio radio-primary ml-5">
                                  <input
                                    id="radio3"
                                    type="radio"
                                    name="occupation"
                                    value={"professional"}
                                    checked={
                                      form.occupation === "professional"
                                        ? true
                                        : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label className="mb-0" for="radio3">
                                    {strings.professional}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-2">
                            <label htmlFor="exampleFormControlLastName">
                              {strings.companyName}
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlLastName"
                              type="text"
                              name="coumpany_name"
                              value={form.coumpany_name}
                              placeholder={strings.companyName}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlLastName">
                              {strings.desigantion}
                            </label>
                            <input
                              className="form-control"
                              id="exampleFormControlLastName"
                              type="text"
                              name="desigantion"
                              value={form.desigantion}
                              placeholder={strings.desigantion}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1">
                              {strings.officeaddress}
                            </label>
                            <div className="row">
                              <div className="col-md-6 pb-3">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="office_address"
                                  value={form?.office_address?.house_no}
                                  placeholder={strings.houseNo}
                                  onChange={(e) => {
                                    setForm({
                                      ...form,
                                      office_address: {
                                        ...form.office_address,
                                        house_no: e.target.value,
                                      },
                                    });
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                              <div className="col-md-6">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="office_address"
                                  value={form?.office_address?.area}
                                  placeholder={strings.officeArea}
                                  onChange={(e) => {
                                    setForm({
                                      ...form,
                                      office_address: {
                                        ...form.office_address,
                                        area: e.target.value,
                                      },
                                    });
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6 pb-3">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="office_address"
                                  value={form.office_address?.landmark}
                                  placeholder={strings.landmark}
                                  onChange={(e) => {
                                    setForm({
                                      ...form,
                                      office_address: {
                                        ...form.office_address,
                                        landmark: e.target.value,
                                      },
                                    });
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                              <div className="col-md-6 ml-15 d-flex">
                                <AutocompletePlace
                                  placeholder={strings.location}
                                  value={form?.office_address?.location}
                                  onChange={handleInputlocation}
                                  onSelect={onSelect}
                                  // error={formVaild?.location}
                                  // label={strings.location}
                                  requiredLabel={false}
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="pincode"
                                  value={form.office_address?.pincode}
                                  placeholder={strings.pincode}
                                  onChange={(e) => {
                                    setForm({
                                      ...form,
                                      office_address: {
                                        ...form.office_address,
                                        pincode: e.target.value,
                                      },
                                    });
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1">
                              {strings.officeaddress}
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              name="office_address"
                              value={form.office_address}
                              placeholder={strings.officeaddress}
                              onChange={handleInputField}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 d-flex">
                        <div className="card-footer">
                          <button
                            className="btn btn-color"
                            type="button"
                            onClick={() => {
                              navigatpage(`/createvisitornext/${_id}`);
                            }}
                          >
                            {strings.back}
                          </button>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex justify-content-end">
                        <div className="card-footer">
                          <button
                            className="btn btn-color"
                            type="button"
                            onClick={() => handleSubmit()}
                          >
                            {strings.submit}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <img
                      src={form?.document}
                      className="img-fluid pt-5 h-75"
                      alt=""
                      type="file"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CreateVisitorNext1;
